import { SelectionMode } from '@uifabric/utilities'
import {
  EntityList,
  EntityListProps,
  renderInvertedYesNoIcon,
} from 'components/EntityList'
import { SenderRecipient } from 'model'
import { ConstrainMode } from 'office-ui-fabric-react'
import * as React from 'react'
import { useTranslation } from 'react-i18next'
import { createFieldColumn } from 'views/helpers'

export type SenderRecipientListProps = EntityListProps<SenderRecipient>

export const AdminSenderRecipientList: React.FC<SenderRecipientListProps> = ({
  items,
  ...props
}) => {
  const { t } = useTranslation()

  const fieldColumn = React.useMemo(() => createFieldColumn(t), [t])
  const columns = React.useMemo(
    () => [
      fieldColumn('inactive', {
        minWidth: 40,
        maxWidth: 40,
        name: t('field.active.label'),
        onRender: renderInvertedYesNoIcon,
        ungroupable: true,
      }),
      fieldColumn('supplierNumber', {
        ungroupable: true,
      }),
      fieldColumn('countryCode', {
        ungroupable: true,
      }),
      fieldColumn('name', {
        ungroupable: true,
      }),
      fieldColumn('place', {
        ungroupable: true,
      }),
      fieldColumn('postCode', {
        ungroupable: true,
      }),
      fieldColumn('street', {
        ungroupable: true,
      }),
      fieldColumn('phone', { ungroupable: true }),
    ],
    [fieldColumn]
  )

  return (
    <EntityList
      alternate={true}
      stickyHeader={true}
      selectionMode={SelectionMode.multiple}
      items={items}
      constrainMode={ConstrainMode.horizontalConstrained}
      columns={columns}
      {...props}
    />
  )
}
